const SET_CREATE_CONTROL_POINT = "SET_CREATE_CONTROL_POINT";
const SET_CLEAR_CREATE_CONTROL_POINT = "SET_CLEAR_CREATE_CONTROL_POINT";

const setCrateControlPointAction = (data) => {
  return {
    type: SET_CREATE_CONTROL_POINT,
    data,
  };
};

const setCreateControlPoint = (controlPoint) => {
  return (dispatch) => {
    dispatch(setCrateControlPointAction(controlPoint));

  };
};

const clearCreateControlPointAction = () => {
  return {
    type: SET_CLEAR_CREATE_CONTROL_POINT,
    data: null,
  };
};

const clearCreatePontrolPoint = () => {
  return (dispatch) => {
    dispatch(clearCreateControlPointAction());
  };
};

export { SET_CREATE_CONTROL_POINT, setCreateControlPoint, SET_CLEAR_CREATE_CONTROL_POINT, clearCreatePontrolPoint };
